// useFEList.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config';

const useFEList = () => {
  const [feList, setFEList]       = useState([]);
  const [feLoading, setFELoading] = useState(false);
  useEffect(() => {
    setFELoading(true);
    axios.get(`${API_BASE_URL}/fe-mgmt/fe-base/`)
      .then(r => setFEList(Array.isArray(r.data) ? r.data : []))
      .catch(() => setFEList([]))
      .finally(() => setFELoading(false));
  }, []);
  return { feList, feLoading };
};

export default useFEList;